import { ClipboardList } from 'lucide-react';
import React from 'react';
import { useTranslation } from 'react-i18next';

const IncidentClusterTooltip = ({ count, titles }) => {
  const { t } = useTranslation();

  const translatedTitle = title => {
    const [number, data] = title.split(' - ');
    const translatedText = t('INCIDENT_TYPES', { returnObjects: true }).find(item => item.value === data)?.label;
    return translatedText ? `${number} - ${translatedText}` : title;
  };

  return (
    <div className="bg flex flex-col gap-2 p-3 rounded-lg shadow-lg">
      <div className="flex flex-row items-center gap-1 border-b border-muted pb-2">
        <ClipboardList size={16} />
        <span className="font-semibold text-sm align-middle">{t('MAP_VIEW.INCIDENT_CLUSTER_TOOLTIP.INCIDENTS')}</span>
      </div>
      <ul className="text-xs font-normal">
        {titles.slice(0, 3).map((t, i) => (
          <li key={i}>{translatedTitle(t)}</li>
        ))}
      </ul>
      {count > titles.length && (
        <div className="text-muted text-xs mt-1">
          +{count - titles.length} {t('MAP_VIEW.INCIDENT_CLUSTER_TOOLTIP.MORE')}
        </div>
      )}
    </div>
  );
};

export default IncidentClusterTooltip;
